import { Container } from "./UaePassRedirection.styled";
import { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import CONSTANTS from "../../utils/constants";
import {Spinner} from "../../components/spinner.component"
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { NotifyError } from "../../utils/ShowError";
import { toJS } from "mobx";



const UaePassRedirection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    prepareData();
  }, []);
  const  logoutUaePassUrl =(uaePassconfiguration:any)=> {
      let uaePassEndpoint = uaePassconfiguration.uaePassLogOutEndPoint;
      let redirectURI = uaePassconfiguration.redirectURL;
     
      let uaePasslogoutURL = uaePassEndpoint + 'redirect_uri=' + redirectURI.replace('Account/UAEPassRedirect',"");    
      return uaePasslogoutURL;
    }
  const prepareData = async () => {

    console.log(location.pathname);


    let error = searchParams.get('error');
    console.log("error: " + error);

    let code = searchParams.get('code');
    console.log("code: " + code);

    let state = searchParams.get('state');
    console.log("state: " + state);

    if (error) {//fail case
      NotifyError(General?.codeLabels['cm_loginunsuccessful']?.label?General?.codeLabels['cm_loginunsuccessful']?.label:"Login was unsuccessful.")
      navigate('/');
    }
    else {


      if (code && state) 
      {
        await User.redirectUAEPass({code, state});

        console.log(toJS(User.uaePassDetails))
        if (User.uaePassDetails) {
          if (User.uaePassDetails.userType!="SOP1") {
            let data = {
              uuid: User.uaePassDetails.uuid ? User.uaePassDetails.uuid : null,
              emiratesId: User.uaePassDetails.emiratesId
                ? User.uaePassDetails.emiratesId
                : null,
                uaepassenabled: true,
            };
            await User.loginUaePass({
              data,
              errorId: "loginError",
            });
            if (User.info.status==true && User?.info?.token) {
              window.localStorage.setItem("user", JSON.stringify(User?.info));
              window.localStorage.setItem("us_tkn", User?.info?.token);
              window.localStorage.setItem("username", User?.info?.userName);
              User.getProfile(User.info.personId as string);
              User.getFavourites();
              localStorage.setItem('isUaePass','true')
              navigate("/dashboard");
            }else if(User.info.reasonCode == 15 || User.info.reasonCode == 5){
              localStorage.setItem('reasonCode',User.info.reasonCode)
              localStorage.setItem('redirectFrom',"uaePassLogin")
              navigate('/movein-registration');
            }else if(User.info.reasonCode == 14){
              NotifyError(User?.info?.message)
              navigate('/')
            }else if(User.info?.reasonCode == 6||User?.info?.reasonCode==7){
              window.localStorage.setItem("user", JSON.stringify(User?.info));
              window.localStorage.setItem("us_tkn", User?.info?.token);
              window.localStorage.setItem("username", User?.info?.userName);
              User.getProfile(User.info.personId as string);
              User.getFavourites();
              localStorage.setItem('isUaePass','true')
              navigate("/dashboard");
            }
          }
          else {
            // NotifyError(General?.codeLabels['cm_acct_unverified']?.label?General?.codeLabels['cm_acct_unverified']?.label:"Your Account Is Unverified, Please Visit the Nearest UAE PASS Kiosk")
            await User?.uaeGetConfig()
           const uaePasslogoutURL= logoutUaePassUrl(User?.uaePassConfigDetails);
           localStorage.setItem("uaePassUnverified", "1");
            window.open(uaePasslogoutURL, '_self');
          }
        } else {
          console.log("***MA fiii bil UAE");
        }
      }
    }

  };


  return (
    <Container>
      <p></p>
      <Spinner />
    </Container>
  );
};

export default UaePassRedirection;